// Reason: Angular Inject issues...
/* eslint-disable @typescript-eslint/no-explicit-any */
import { MouseEvent } from 'react';
import { Link, LinkProps } from 'react-router-dom';

interface Props extends LinkProps {
	to: string;
	isCurrentPage?: boolean;
	className?: string;
	__TEMP__navigate?(url: string): void;
	__TEMP__to: string;
}

// const elements = {};

export function VisibaLink({
	to,
	__TEMP__to,
	__TEMP__navigate,
	className,
	children,
	onClick,
	isCurrentPage,
	...rest
}: Props): JSX.Element {
	function handleClick(event: MouseEvent<HTMLAnchorElement>): void {
		if (onClick) {
			onClick(event);
		}

		if (__TEMP__navigate) {
			event.preventDefault();

			__TEMP__navigate(__TEMP__to);

			return;
		}
	}

	// For Injection purposes...
	if (window.__TEMP__) {
		return (
			<a
				href={__TEMP__to}
				onClick={handleClick}
				className={className}
				aria-current={isCurrentPage ? 'page' : undefined}
				{
					// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
					...(rest as any) /* TODO: REMOVE INJECTION ISSUES */
				}
			>
				{children}
			</a>
		);
	}

	return (
		<Link to={to} onClick={onClick} className={className} aria-current={isCurrentPage ? 'page' : undefined} {...rest}>
			{children}
		</Link>
	);
}
